import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=475957be&"
import script from "./Admins.vue?vue&type=script&lang=js&"
export * from "./Admins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('475957be')) {
      api.createRecord('475957be', component.options)
    } else {
      api.reload('475957be', component.options)
    }
    module.hot.accept("./Admins.vue?vue&type=template&id=475957be&", function () {
      api.rerender('475957be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admins.vue"
export default component.exports